<template>
  <a class="ps-inline-flex ps-items-center">
    <span><slot /></span>
    <span class="ps-inlie-flex ps-items-center ps-ml-2 ps-svg-down">
      <svg-icon name="go" width="16" height="auto" />
    </span>
  </a>
</template>

<script>
export default {
  name: 'LinkWithIcon'
}
</script>
